import React, {useContext, useState} from "react";
import './DatumSelection.css';
import Calendar from "react-calendar";
import {SelectedDateContext} from "../../../contexts/date/SelectedDateContext";
import {useIntl} from "react-intl";
import {getLocale} from "../../../contexts/language/LanguageContext";

const DatumSelection = () => {
    const [dateValue, setDateValue] = useState(new Date());
    const [, setSelectedDateContext] = useContext(SelectedDateContext);
    const intl = useIntl();
    const onClickDay = (dateValue) => {
        setSelectedDateContext(dateValue);
    }

    return (
        <div>
            <Calendar
                className={'my-calendar'}
                onClickDay={onClickDay}
                onChange={setDateValue}
                value={dateValue}
                locale={getLocale(intl.locale)}
            />
        </div>
    );
}

export default DatumSelection;